import { ButtonAccordionProps } from "./types"
import React from "react"
import { ButtonText } from "~components/button"
import { Accordion } from "~widgets/accordion"
import styled from '~/ui/styled'

const Center = styled.View`
  flex: 1;
  justify-content: center;
  flex-direction: row;
`

const ButtonAccordion: React.FC<ButtonAccordionProps> = ({ buttonTextProps, accordionProps }) => {
  return (
    <Accordion {...accordionProps} hideRightArea={false}>
      <Center>
        <ButtonText {...buttonTextProps} />
      </Center>
    </Accordion>
  )
}

export default ButtonAccordion
